import client from "../Client/HttpClient";
import {IParametersModel} from "@/interfaces/modules";
const ApiPath = "parameters";

export default {
    GetParameters:(): Promise <IParametersModel[]> => client.get(`${ApiPath}`),
    GetParametersById: (data: IParametersModel ):Promise<IParametersModel>=>client.get(`${ApiPath}/${data.Id}`),
    PostParameters : (data:IParametersModel ) : Promise<IParametersModel>=>client.post(`${ApiPath}`, data),
  };